// extracted by mini-css-extract-plugin
export default {"projectsTitle":"Title_projectsTitle__-n-2h","title":"Title_title__FrYS7","separatorLine":"Title_separatorLine__UVclH"};